import { render, staticRenderFns } from "./Flx__Header.vue?vue&type=template&id=2ae9d2f5&lang=pug&"
import script from "./Flx__Header.vue?vue&type=script&lang=js&"
export * from "./Flx__Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports